import { Button, ButtonGroup, Flex } from '@driftt/dds'
import { Icon } from '@driftt/tide-icons'
import React from 'react'

import './styles.css'

const AVAILABLE_SCORES = [-1, 1, 2, 3]

const RatingButton = ({
  rating,
  onClick,
  isSelected,
}: {
  rating: number
  onClick: () => void
  isSelected: boolean
}) => {
  const minus = (
    <Icon className="colored-minus" name="minus" width={14} height="14px" />
  )
  const bolt = (key: number) => (
    <Icon
      className="colored-bolt"
      name="lightning-bolt-filled"
      key={key}
      height="14px"
      width="8px"
    />
  )
  return (
    <Button
      variant="secondary"
      size="small"
      css={{
        width: 32,
        height: 32,
        background: isSelected ? '$blue1' : 'transparent',
        borderColor: isSelected ? '$blue8' : 'gray3',
      }}
      onClick={onClick}
    >
      <Flex direction="row" wrap="nowrap" gap={0}>
        {rating === -1
          ? minus
          : Array(rating)
              .fill('')
              .map((_, i) => bolt(i))}
      </Flex>
    </Button>
  )
}

const CQLRatingGroup = ({
  rating = 0,
  onRatingClick,
}: {
  onRatingClick: (rating: number) => void
  rating?: number
}) => {
  return (
    <ButtonGroup gap={0} align="left" orientation="horizontal">
      {AVAILABLE_SCORES.map((score) => (
        <RatingButton
          rating={score}
          onClick={() => onRatingClick(score)}
          isSelected={rating === score}
        />
      ))}
    </ButtonGroup>
  )
}

export default CQLRatingGroup
